/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_XInputs */

const ja_nav_x = /** @type {(inputs: Nav_XInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公式Xアカウント`)
};

const en_nav_x = /** @type {(inputs: Nav_XInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow on 𝕏`)
};

/**
* | output |
* | --- |
* | "Follow on 𝕏" |
*
* @param {Nav_XInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_x = /** @type {((inputs?: Nav_XInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_XInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_nav_x(inputs)
	return en_nav_x(inputs)
});